import { createEvent, restore, sample } from 'effector'
import {
  Commission,
  CommissionsRequest,
  CommissionsResponse,
  TotalRequest,
  TotalResponse,
} from './types'
import { fx } from '../../../../../libs'
const changedDateFormat = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      if (item[0] === 'paidAt') {
        const value =
          Array.isArray(item[1]) &&
          item[1].map((date) =>
            date ? changedDateFormat(date?.$d) : `${date}`,
          )
        return [item[0], value]
      }
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}
export const commissionsMounted = createEvent<CommissionsRequest>()
export const totalMounted = createEvent<TotalRequest>()

export const getCommissions = fx<CommissionsRequest, CommissionsResponse>({
  method: 'GET',
  url: `/strategy_subscription_payment`,
})
export const getTotal = fx<TotalRequest, TotalResponse>({
  method: 'GET',
  url: `/strategy_subscription_payment/total`,
})

export const $commissions = restore<Commission[]>(
  getCommissions.doneData.map((a) => a.body.items),
  [],
)
export const $total = restore<number>(
  getTotal.doneData.map((a) => a.body.totalUSD),
  0,
)

export const $totalCountOfCommissions = restore(
  getCommissions.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: commissionsMounted,
  fn: ({ strategyId, limit, page, orderBy, orderDirection, searchText }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }
    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    let newObj = {}

    // @ts-ignore
    newObj['strategyId'] = strategyId

    if (!isAllElementsOfSearchTextNotExist(searchText)) {
      newObj = { ...newObj, ...mapSearchText(searchText) }
    }

    if (Object.keys(newObj).length) {
      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    // @ts-ignore
    query['populate'] = JSON.stringify([
      'StrategySubscriptionPayment',
      'StrategySubscriptionPayment.account',
      'StrategySubscriptionPayment.paidAt',
    ])

    return {
      query,
    }
  },
  target: getCommissions,
})

sample({
  // @ts-ignore
  clock: totalMounted,
  fn: ({ strategyId, limit, page, orderBy, orderDirection, searchText }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }
    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    let newObj = {}

    // @ts-ignore
    newObj['strategyId'] = strategyId

    if (!isAllElementsOfSearchTextNotExist(searchText)) {
      newObj = { ...newObj, ...mapSearchText(searchText) }
    }

    if (Object.keys(newObj).length) {
      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    // @ts-ignore
    query['populate'] = JSON.stringify([
      'StrategySubscriptionPayment',
      'StrategySubscriptionPayment.account',
      'StrategySubscriptionPayment.paidAt',
    ])

    return {
      query,
    }
  },
  target: getTotal,
})
